import "../sentry-instrument";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { AppProvider } from "./components/common/AppProvider.tsx";
import App from "./App.tsx";
import { AuthProvider } from "./providers/AuthProvider.tsx";
import { Toaster } from "./components/ui/toaster.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppProvider>
      <AuthProvider>
        <App />
        <Toaster />
      </AuthProvider>
    </AppProvider>
  </StrictMode>,
);
